import type { ScheduledQuotesActivity } from 'apiConnector/scheduledRun/model';
import { IntlKey } from 'locales';
import { connect } from 'react-redux';
import type { ActivityFilter } from 'state/blotters/common/blotter.model';
import { scheduledQuotesBlotterFilterChanged } from 'state/blotters/scheduledQuotes';
import { scheduledQuotesBlotter } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

export type FilterProps = FilterOwnProps & FilterStateProps & FilterDispatchProps;

type FilterOwnProps = {
  className?: string;
  searchPlaceholder?: IntlKey;
};

interface FilterStateProps {
  quickSearchTerm?: string;
  activityFilter: ScheduledQuotesActivity;
  loading: boolean;
  error: boolean;
  totalItems?: number;
}

interface FilterDispatchProps {
  onActivityFilterChanged(value: ActivityFilter): void;
  onQuickSearchTermChanged(value?: string): void;
}

export const mapStateToProps = (state: AppState): FilterStateProps => {
  const { quickSearchTerm, activityFilter } = scheduledQuotesBlotter.getFilters(state);
  const loading = scheduledQuotesBlotter.getScheduledQuotesBlotterLoading(state);
  const error = scheduledQuotesBlotter.getScheduledQuotesBlotterError(state);
  const { totalItems } = scheduledQuotesBlotter.getPaginationInfo(state);
  return {
    quickSearchTerm,
    activityFilter,
    loading,
    error,
    totalItems,
  };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch): FilterDispatchProps => ({
  onActivityFilterChanged(activity) {
    if (activity === 'all') {
      throw new Error('Should not be all');
    }
    dispatch(scheduledQuotesBlotterFilterChanged('activityFilter', activity));
  },

  onQuickSearchTermChanged(value) {
    dispatch(scheduledQuotesBlotterFilterChanged('quickSearchTerm', value));
  },
});

export const connectFilterComponent = connect(mapStateToProps, mapDispatchToProps);
